import Button from 'antd/lib/button'
import ModalComp from 'Components/common/Modal/Modal'
import styles from './ActionModal.module.less'

export type ActionModalPropsType = {
    title?: string | React.ReactElement
    content?: string | React.ReactElement
    getVisibility: () => boolean
    primaryButtonName?: string
    secondaryButtonName?: string
    closable?: boolean
    onConfirm: () => void
    onCancel?: () => void
}

export const ActionModal: React.FC<ActionModalPropsType> = (props: ActionModalPropsType) => {
    return (
        <div data-testid="action-modal-wrapper">
            <ModalComp
                width="400px"
                visible={props.getVisibility() ?? false}
                modalHeader={
                    <div className={styles['modal-header']}>
                        <div className={styles['modal-title']}>{props.title}</div>
                    </div>
                }
                modalFooter={
                    <div className={'modal-button'}>
                        {props.onCancel && (
                            <Button onClick={props.onCancel}>
                                {props.secondaryButtonName ?? 'Cancel'}
                            </Button>
                        )}
                        <Button
                            type="primary"
                            onClick={props.onConfirm}
                            data-testid="primary-modal-submit"
                        >
                            {props.primaryButtonName ?? 'Yes'}
                        </Button>
                    </div>
                }
                onCancel={props.onCancel}
                closable={props.closable}
            >
                <div className={styles['modal-container-parent']}>
                    <span>{props.content}</span>
                </div>
            </ModalComp>
        </div>
    )
}
